import { createContext } from 'react';
import { makeAutoObservable } from 'mobx';
import type { UserInfo } from './types';

/**
 * 跨微应用间共享
 *
 * RootStore 负责微应用内部的状态管理
 * SharedStore 负责微应用间的状态管理，需要跨微应用共享的数据应该放在这里
 */
export class SharedStore {

  collapsed = false;
  user?: UserInfo = undefined;

  constructor() {
    makeAutoObservable(this);
  }

  setCollapsed(value: boolean): void {
    this.collapsed = value;
  }

  setUser(value: UserInfo | undefined): void {
    this.user = value;
  }

}

export const SharedContext = createContext<SharedStore>(new SharedStore());
export const SharedProvider = SharedContext.Provider;
